import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FleetGeneralFigureService } from 'src/app/_services/fleet-general-figure.service';
import { BatteryTypeOption, toBatteryTypeFilter, toBatteryTypeSeries } from 'src/app/_shared/utils/battery-type';
import { TransformXAxisPipe } from 'src/app/_shared/pipes/transform-xaxis.pipe';
import { createPlotlyChart } from 'src/app/_shared/plotlyConfig';

@Component({
  selector: 'app-current-sohc-chart',
  templateUrl: './current-sohc-chart.component.html',
  styleUrls: ['./current-sohc-chart.component.scss']
})
export class CurrentSohcChartComponent implements OnChanges, OnDestroy {
  private readonly unsubscribe$ = new Subject<void>();
  @Input() fleetId: string[] = [];
  @Input() selectedBatteryTypes: BatteryTypeOption[] = [];
  sohcFleetDatapoints: any = [];
  errorMessage: boolean = false;
  dataLoading: boolean = false;
  chartRange!: { range: [number, number]};
  
  constructor(
    private readonly fleetGeneralFigureService: FleetGeneralFigureService
  ) {}

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  
  ngOnChanges(): void {
    this.dataLoading = true;
    this.errorMessage = false;
    this.fleetGeneralFigureService.getSohcFleet(this.fleetId, toBatteryTypeFilter(this.selectedBatteryTypes)).pipe(takeUntil(this.unsubscribe$)).subscribe(
      {
        next: (datapoints) => {
          this.plotCurrentSohcChart(datapoints);
        },
        error: (error) => {
          console.error('Error fetching Current State of Health Fleet data:', error);
          this.dataLoading = false;
          this.errorMessage = true;
        },
        complete: () => {
          this.dataLoading = false;
        }
      }
    )
  }
  
  plotCurrentSohcChart(datapoints: any) {
    const transformXAxisPipe = new TransformXAxisPipe();
    const data = toBatteryTypeSeries(datapoints, this.selectedBatteryTypes).map((series) => ({
      x: series.datapoints.map((dataObject: any) => dataObject.binSoh),
      y: series.datapoints.map((dataObject: any) => dataObject.percVeh),
      type: 'bar',
      name: series.label,
      marker: {
        color: series.color
      }
    }));
    this.chartRange = transformXAxisPipe.transform(data.flatMap((trace) => trace.x), data.flatMap((trace) => trace.y), 5, 100);
    
    const layout = {
      title: 'Current State of Health',
      font: {
        family: 'boschsans, Helvetica Neue, Helvetica, Arial, sans-serif',
        size: 13,
      },
      barmode: 'group',
      xaxis: {
        title: 'State of Health [%]',
        range: this.chartRange?.range
      },
      yaxis: {
        title: 'Percentage of Fleet Vehicles [%]'
      },
      showlegend: true,
      legend: {
        orientation: 'h', 
        y: -0.3, 
        xanchor: 'center', 
        x: 0.5,
        font: {
          family: 'boschsans, Helvetica Neue, Helvetica, Arial, sans-serif',
          size: 13,
        },
      }
    };
    
    createPlotlyChart('current-sohc-chart', data, layout);
  }
  
}